module.exports = __webpack_public_path__ + "img/intro_ybooks.ffc7b30e.png";